<div class="flex flex--column g-medium">
  <h2 class="nordic-blue-900-text text-icon-primary font-heading-4 font-title-medium" data-testid="car-rental-title">
    {{ 'bookingWidgetTabs.carTrawler.title' | finLocalization }}
  </h2>

  <div class="header flex flex--middle flex--space-between">
    <div class="poweredby flex flex--middle">
      <span class="ms-xsmall-r">{{ 'bookingWidgetTabs.carTrawler.poweredBy' | finLocalization }}</span>
      <div class="rounded-large" [ngClass]="{ 'surface-static-light ps-xsmall-x ps-xxsmall-y': isDarkTheme() }">
        <fcom-icon class="logo" [category]="IconLibrary.CUSTOM" [name]="CustomIcon.CARTRAWLER_LOGO" />
      </div>
    </div>
    <fcom-checkbox-input [parentForm]="checkboxForm" [controlName]="'differentDropoff'">
      <span class="font-body-1 font-body-medium">
        {{ 'bookingWidgetTabs.carTrawler.differentDropoff' | finLocalization }}
      </span>
    </fcom-checkbox-input>
  </div>

  <div class="flex flex--column g-small">
    <fin-location-selector
      [singleLocation]="true"
      [originLabel]="
        (form.differentDropoff().value()
          ? 'bookingWidgetTabs.carTrawler.pickupLocation'
          : 'bookingWidgetTabs.carTrawler.pickupAndDropoff'
        ) | finLocalization
      "
      [originPlaceholder]="'bookingWidgetTabs.carTrawler.locationPlaceholder' | finLocalization"
      [airportsOnly]="true"
      [skipDefaultOriginFetch]="false"
      [showSuggestedDestinations]="true"
      [showLocateMe]="true"
      [showPreviousSearches]="false"
      [locationPair]="{ origin: form.pickupLocation().value() ?? undefined }"
      (setLocations)="onPickupSelected($event)"
    />

    @if (form.differentDropoff().value()) {
      <fin-location-selector
        [singleLocation]="true"
        [originLabel]="'bookingWidgetTabs.carTrawler.dropoffLocation' | finLocalization"
        [originPlaceholder]="'bookingWidgetTabs.carTrawler.locationPlaceholder' | finLocalization"
        [airportsOnly]="true"
        [skipDefaultOriginFetch]="false"
        [showSuggestedDestinations]="true"
        [showLocateMe]="true"
        [showPreviousSearches]="false"
        [locationPair]="{ origin: form.dropoffLocation().value() ?? undefined }"
        (setLocations)="onDropoffSelected($event)"
      />
    }
  </div>

  @if (form.pickupLocation().value()) {
    <div class="dates flex flex--column g-small">
      <div class="datetimes g-small">
        <div class="datetime-group">
          <fin-booking-widget-selector
            [label]="'bookingWidgetTabs.carTrawler.pickupDate' | finLocalization"
            [placeholder]="'bookingSearch.boundSelection.selectDatePlaceholder' | finLocalization"
            [ariaLabel]="'bookingWidgetTabs.carTrawler.pickupDate' | finLocalization"
            [filled]="!!pickupLocalDate()"
            [position]="'left'"
            (click)="openDateModal('pickup')"
            data-testid="car-rental-pickup-date-selector"
          >
            @if (pickupLocalDate(); as date) {
              <span>{{ date | finDateFormat: 'FULL_NO_YEAR' }}</span>
            }
          </fin-booking-widget-selector>

          <fin-booking-widget-selector
            class="time"
            [label]="'bookingWidgetTabs.carTrawler.time' | finLocalization"
            [placeholder]="'bookingWidgetTabs.carTrawler.selectTimePlaceholder' | finLocalization"
            [ariaLabel]="'bookingWidgetTabs.carTrawler.pickupTime' | finLocalization"
            [filled]="!!form.pickupTime().value()"
            [position]="'right'"
            (click)="openTimeModal('pickup')"
            data-testid="car-rental-pickup-time-selector"
          >
            @if (form.pickupTime().value(); as time) {
              <span>{{ time }}</span>
            }
          </fin-booking-widget-selector>
        </div>

        <div class="datetime-group">
          <fin-booking-widget-selector
            [label]="'bookingWidgetTabs.carTrawler.dropoffDate' | finLocalization"
            [placeholder]="'bookingSearch.boundSelection.selectDatePlaceholder' | finLocalization"
            [ariaLabel]="'bookingWidgetTabs.carTrawler.dropoffDate' | finLocalization"
            [filled]="!!dropoffLocalDate()"
            [position]="'left'"
            (click)="openDateModal('dropoff')"
            data-testid="car-rental-dropoff-date-selector"
          >
            @if (dropoffLocalDate(); as date) {
              <span>{{ date | finDateFormat: 'FULL_NO_YEAR' }}</span>
            }
          </fin-booking-widget-selector>

          <fin-booking-widget-selector
            class="time"
            [label]="'bookingWidgetTabs.carTrawler.time' | finLocalization"
            [placeholder]="'bookingWidgetTabs.carTrawler.selectTimePlaceholder' | finLocalization"
            [ariaLabel]="'bookingWidgetTabs.carTrawler.dropoffTime' | finLocalization"
            [filled]="!!form.dropoffTime().value()"
            [position]="'right'"
            (click)="openTimeModal('dropoff')"
            data-testid="car-rental-dropoff-time-selector"
          >
            @if (form.dropoffTime().value(); as time) {
              <span>{{ time }}</span>
            }
          </fin-booking-widget-selector>
        </div>
      </div>

      <div class="age flex g-small flex--center">
        <span class="font-body-1 medium-type font-label-medium nowrap">
          {{ 'bookingWidgetTabs.carTrawler.driverAge' | finLocalization }}
        </span>
        <fcom-radio-item-group
          class="flex-1"
          [parentForm]="ageForm"
          [controlName]="'driverAge'"
          [options]="ageOptions"
          [translationPrefix]="'bookingWidgetTabs.carTrawler.driverAgeSelection'"
          [titleText]="false"
          [isHorizontal]="true"
          [ariaLabel]="'bookingWidgetTabs.carTrawler.driverAge' | finLocalization"
        />
        <fcom-button
          [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
          [size]="ButtonSize.LARGE"
          [mode]="ButtonMode.FILL"
          [text]="'bookingWidgetTabs.carTrawler.ctaButton' | finLocalization"
          [icon]="{ name: SvgLibraryIcon.EXTERNAL_TAB, position: IconPosition.RIGHT }"
          [disabled]="form().valid() === false"
          (clickBtn)="onSearch()"
          data-testid="car-rental-search-button"
        />
      </div>
    </div>
  }

  <fcom-notification [layout]="NotificationLayout.BLOCK" [iconName]="SvgLibraryIcon.AVIOS_CURRENCY">
    <p class="medium-type">
      {{ 'bookingWidget.carTrawler.aviosNotification' | finLocalization }}
    </p>
  </fcom-notification>
</div>

<fcom-modal
  [open]="datesModalOpen"
  [fitToContent]="true"
  [buttons]="null"
  [fullHeight]="true"
  [extraWide]="true"
  [roundedContent]="true"
  (close)="closeDatesModal()"
  data-testid="car-rental-dates-modal"
>
  <fcom-datepicker
    [uiLabels]="datepickerLabels$ | async"
    [dateLabels]="dateLabels$ | async"
    [isDateRange]="false"
    [selectableDatesRange]="datepickerRange()"
    [selectedDates]="datepickerSelectedDates()"
    [showTags]="false"
    (selectedDatesChange)="updateSingleDate($event)"
    (close)="closeDatesModal()"
  />
</fcom-modal>

<fcom-modal
  [open]="timeModalOpen"
  [title]="
    (activeTimeField() === 'dropoff'
      ? 'bookingWidgetTabs.carTrawler.dropoffTime'
      : 'bookingWidgetTabs.carTrawler.pickupTime'
    ) | finLocalization
  "
  [fitToContent]="true"
  [buttons]="null"
  [roundedContent]="true"
  (close)="closeTimeModal()"
  data-testid="car-rental-time-modal"
>
  @if (timeModalOpen) {
    <ul class="time-list no-list-style">
      @for (time of timeOptions; track time.value) {
        <li>
          <button
            type="button"
            class="time-option flex flex--center flex--space-between fill ps-small-x ps-medium-y"
            [class.time-option--selected]="time.value === activeTimeValue()"
            [attr.aria-pressed]="time.value === activeTimeValue()"
            (click)="selectTime(time.value)"
          >
            <span>{{ time.name }}</span>
            @if (time.value === activeTimeValue()) {
              <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.CHECKMARK" />
            }
          </button>
        </li>
      }
    </ul>
  }
</fcom-modal>
